import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig, GiveawayTabEnum } from '../types'

export const createBaseConfig = (overrides: Partial<GiveawayConfig>): GiveawayConfig => ({
  theatricalSlug: '',
  heroTitle: '',
  logoUrl: '',
  inTheatersText: '',
  galleryImages: [],
  tabs: [],
  ...overrides,
})

export const createStandardTabs = (t: TranslateFunction) => [
  { title: t('prizeItemsTech', 'Prize Items'), type: GiveawayTabEnum.Prizes },
  { title: t('details', 'Details'), type: GiveawayTabEnum.Details },
  { title: t('faq', 'FAQ'), type: GiveawayTabEnum.Faq },
]

export const createStandardSteps = (t: TranslateFunction) => [
  {
    title: t('preOrderTicketsV2', 'Preorder Tickets'),
    description: t('selectTicketsStep1DescriptionRule', 'Select a ticket pack from our exclusive options.'),
  },
  {
    title: t('preOrderTicketsStep2', 'Get Your Promo Codes'),
    description: t(
      'preOrderTicketsStep2DescriptionRule',
      'Receive a promo code for each ticket you pre-order, redeemable when showtimes are available.',
    ),
  },
]

interface TicketFlowParams {
  t: TranslateFunction
  congratsKey: string
  congratsText: string
  portraitImage: string
  reservationKey: string
  reservationText: string
  noShowtimesKey: string
  noShowtimesText: string
  landscapeImage: string
  projectSlug: string
}

export const createStandardTicketFlow = ({
  congratsText,
  portraitImage,
  landscapeImage,
  noShowtimesText,
  reservationText,
}: TicketFlowParams) => ({
  congratsModal: {
    text: congratsText,
    image: portraitImage,
    alt: '',
  },
  reservationCompletePage: {
    image: portraitImage,
    alt: '',
    text: reservationText,
  },
  noShowtimes: {
    image: landscapeImage,
    text: noShowtimesText,
  },
})

export const angelImagesUrl = (path: string) => `https://images.angelstudios.com/image/upload/${path}`
export const staticAssetUrl = (path: string) => `/${path}`
